import {apsViewModels} from "../../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../../shared/dto/aps.enums";
import {apsCommands} from "../../../shared/dto/aps.commands";
import {apsCommon} from "../../../shared/dto/aps.common";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../../http/http.service";
import AuthDataServiceName, {AuthDataService} from "../../auth/authData.service";
import {Endpoints} from "../../../shared/config/constant.module";
let requires = [HttpServiceName, AuthDataServiceName];

export interface WellKnownChecksService {
    saveWellKnownCheckResult(weightItem: apsViewModels.FurnacePullReportWeightItem): angular.IPromise<any>;
    deleteWellKnownCheckResult(weightItem: apsViewModels.FurnacePullReportWeightItem): angular.IPromise<any>;
}

export default angular
  .module('aps.services.wellKnownChecks', requires)
  .service('wellKnownChecksService', (httpService: HttpService,
                                 authDataService: AuthDataService): WellKnownChecksService => {

    let saveWellKnownCheckResult = (weightItem: apsViewModels.FurnacePullReportWeightItem) =>
      httpService
        .post(Endpoints.WELL_KNOWN_CHECKS_RESULTS + '/' + weightItem.wellKnownCheckResultId, { 
            bottleWeight: weightItem.bottleWeight,
            comments: weightItem.comments
        })
        .then((data) => {
          return data;
        });

    let deleteWellKnownCheckResult = (weightItem: apsViewModels.FurnacePullReportWeightItem) =>
      httpService
        .delete(Endpoints.WELL_KNOWN_CHECKS_RESULTS + '/' + weightItem.wellKnownCheckResultId)
        .then((data) => {
          return data;
        });

    return {
        saveWellKnownCheckResult: saveWellKnownCheckResult,
        deleteWellKnownCheckResult: deleteWellKnownCheckResult,
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/checkLists/wellKnownChecks/wellKnownChecks.service.ts